export const courseLevelAnalyticsTabs = (
  organizationId: string,
  courseId: string,
) => [
  {
    title: 'Overview',
    link: `/manage/${organizationId}/analytics/course/${courseId}/overview`,
  },
  {
    title: 'Learners',
    link: `/manage/${organizationId}/analytics/course/${courseId}/learners`,
  },
];
